import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/monthDiscountRule/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/monthDiscountRule/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/monthDiscountRule/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/monthDiscountRule/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/monthDiscountRule/update/v2', params, options);

export const getParkList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', Object.assign({}, options, {
    params
  }));

export const monthChargeRuleList = (params, options) =>
  request.get(
    '/api/v4ward/car/monthChangeRule/monthChargeRuleList/v2',
    Object.assign({}, options, {
      params
    })
  );
export const disable = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRule/disable/v2', qs.stringify(params), options);

export const removeFeeDetail = (params, options) =>
  request.post('/api/v4ward/car/monthChangeRuleDetail/physicsDeleteById/v2', params, options);

export const monthDiscountRuleList = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/MonthDiscountRuleList/v2',
    Object.assign({}, options, {
      params
    })
  );
